export default __webpack_public_path__ + "static/media/white_campaign.35df3558.svg";